import {
  Pagination as MuiPagination,
  PaginationItem as MuiPaginationItem,
  type PaginationItemProps as MuiPaginationItemProps,
  type PaginationProps as MuiPaginationProps
} from "@mui/material";

export type PaginationProps = MuiPaginationProps;
export type PaginationItemProps = MuiPaginationItemProps;

export const Pagination = MuiPagination;
export const PaginationItem = MuiPaginationItem;
